import { MappedClass, MappedProperty } from '@h5s/util-object';

interface SendAstatDailyIstatClosureRequestFields {
  ownerIstatId: number;
  year: number;
  month: number;
}

@MappedClass()
export class SendAstatDailyIstatClosureRequest implements SendAstatDailyIstatClosureRequestFields {
  @MappedProperty()
  ownerIstatId: number;

  @MappedProperty()
  year: number;

  @MappedProperty()
  month: number;

  constructor(fields?: SendAstatDailyIstatClosureRequestFields) {
    if (!fields) return;

    Object.assign(this, fields);
  }
}
